const CareerCard = ({ career }) => (
  <div className="bg-white rounded-xl shadow-card hover:shadow-card-hover transition-all duration-300 overflow-hidden border border-slate-100 flex flex-col h-full transform hover:-translate-y-1 relative z-0">
    <div className="h-2 w-full" style={{ backgroundColor: '#0004f6' }}></div>
    <div className="p-6 flex-grow flex flex-col">
      <div className="mb-4">
        <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{career.facultad}</span>
        <h3 className="text-xl font-bold text-slate-800 mt-1 leading-tight">{career.nombre}</h3>
      </div>

      <div className="space-y-2 mb-6 flex-grow">
        <div className="flex items-center text-sm text-slate-600">
          <span className="w-2 h-2 rounded-full bg-primary-500 mr-2"></span>
          <span className="font-medium">Título:</span> <span className="ml-1">{career["título obtenido"]}</span>
        </div>
        <div className="flex items-center text-sm text-slate-600">
          <span className="w-2 h-2 rounded-full bg-accent-500 mr-2"></span>
          <span className="font-medium">Modalidad:</span> <span className="ml-1">{career.modalidad}</span>
        </div>
      </div>

      <div className="mt-auto pt-4 border-t border-slate-100">
        <a
          href={career.sitioWeb}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-center py-2 px-4 border border-primary-500 text-primary-600 rounded-lg font-semibold hover:bg-primary-50 transition-colors text-sm cursor-pointer relative z-10"
        >
          Más Información
        </a>
      </div>
    </div>
  </div>
);

const CareerList = ({ carreras, groupByFaculty = false }) => {
  const facultadMap = {
    "Facultad de Ciencias Agrarias": "Facultad de Ciencias Agrarias",
    "Facultad de Ciencias Económicas": "Facultad de Ciencias Económicas",
    "Facultad de Ciencias Sociales": "Facultad de Ciencias Sociales",
    "Facultad de Derecho": "Facultad de Derecho",
    "Facultad de Ingeniería": "Facultad de Ingeniería"
  };

  if (groupByFaculty) {
    const facultadOrder = Object.keys(facultadMap);

    // Group logic
    const grouped = carreras.reduce((acc, carrera) => {
      if (!acc[carrera.facultad]) acc[carrera.facultad] = [];
      acc[carrera.facultad].push(carrera);
      return acc;
    }, {});

    const sortedFacultades = [...new Set(facultadOrder.filter(fac => grouped[fac]))];

    return (
      <div className="space-y-12">
        {sortedFacultades.map((facultad) => (
          <div key={facultad} className="relative">
            <div className="flex items-center mb-6">
              <h2 className="text-2xl font-bold text-primary-900 pr-4 bg-slate-50 z-10">{facultadMap[facultad]}</h2>
              <div className="flex-grow h-px bg-slate-200"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {grouped[facultad].map(c => (
                <CareerCard key={c.id} career={c} />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    // Flat list logic for search results
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {carreras.map(c => (
          <CareerCard key={c.id} career={c} />
        ))}
      </div>
    );
  }
};
export default CareerList;